import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "HOW great engineers hack The Process",
  "description": "",
  "published": "2020-03-06T00:00:00.000Z",
  "redirect_from": ["/blog/how-great-engineers-hack-the-process/swizec/9346"],
  "categories": "Opinions, Personal",
  "hero": "./img/95teOop.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Earlier this week we talked about `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/why-great-engineers-hack-the-process/swizec/9344"
      }}>{`why engineers hack the process`}</a>{`. Today I wanna talk about how.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/5068c/95teOop.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "81.61434977578475%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'326\\'%20viewBox=\\'0%200%20400%20326\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M38%208l-6%207-4%206c1%200%202%200%202-2%204-5%204%2053%200%2083-4%2022-4%2028-3%20121v70h-3l-8-1c-5-2-11-2-12-1l2%201h9l9%203c3%200%203%200%202%203l1%203%201-3v-3l15-1h149c29%200%2049%200%2068-2a920%20920%200%20015-1c-44%202-64%203-64%201v-2l-1%202-29%201H29v-23c-1-156-1-147%204-179l1-44c0-31%201-33%203-35l2-3v5l1%205V5l-2%203m175%2049l13%201h19v7l-3%2019c-2%2016-2%2041%200%2042v-1c-1-2%200-29%202-45l2-17%201-6-18-1c-12%200-17%200-16%201M88%2058H73l-32%202h2l25-1h23v7l-2%2011c-3%208-5%2023-5%2033l2%2024c1%200%201-3-1-21%200-9%202-29%206-38%202-6%202-18-1-18l-2%201m15%207l-1%2011a234%20234%200%2000-5%2049c0-10%203-33%206-49%202-9%202-15%201-17-1-1-1%201-1%206m250%20161h-15v8h-90v-7h-16l-16%201%207%201h22c1%200%202%201%202%203v4h92v-4c0-5%200-5%2028-5l21-1-10-1-25%201m-207%203l-22%202-13%201v9H92v-6l1-5h-6l-16%201-20%201h-8c4%201%2032%201%2043-1h6v5l-1%206h18l3%201v-5c0-4%200-5%202-5a421%20421%200%200143-4h-11\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/ca0a1/95teOop.webp 223w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/75680/95teOop.webp 445w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/8d1ba/95teOop.webp 890w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/3838e/95teOop.webp 1335w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/e11e5/95teOop.webp 1780w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/e0fd9/95teOop.webp 1917w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/e92b6/95teOop.png 223w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/e66bf/95teOop.png 445w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/4ef49/95teOop.png 890w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/4e814/95teOop.png 1335w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/701e9/95teOop.png 1780w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/5068c/95teOop.png 1917w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/4ef49/95teOop.png",
              "alt": "95teOop",
              "title": "95teOop",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`The Process is like an organization's immune system against the incompetent, the lazy, and the too busy to pay attention. Safety rails to make sure everyone does at least sort of good work no matter what.`}</p>
    <p>{`We can't trust you to run tests? Fine, no merging without a green test suite.`}</p>
    <p>{`We can't trust you to dev test your code? Fine, not done without independent sign-off.`}</p>
    <p>{`Can't trust you to think through your solution before coding? Fine, no starting without an engineering kickoff.`}</p>
    <p>{`Can't even trust you to read the spec? Fine, no coding without a detailed time estimate verified and agreed upon by five independent parties.`}</p>
    <p><img parentName="p" {...{
        "src": "/75b9bf32c6b0ed8a2038ae6846a34d13/media-uAthSflgJlpwykLSXf-giphy.gif",
        "alt": "groan giphy"
      }}></img></p>
    <p>{`But you're a great engineer. Never incompetent, rarely lazy, and always too busy to pay attention ... wait a minute 🤔`}</p>
    <h2 {...{
      "id": "hacking-the-process"
    }}>{`Hacking The Process`}</h2>
    <p>{`So how do you hack The Process when it gets in the way?`}</p>
    <p><strong parentName="p">{`trust`}</strong></p>
    <p>{`First you have to build trust. Without trust you won't have the leeway to hack the process.`}</p>
    <p>{`Trust is best built by not fucking up.`}</p>
    <p>{`Think of trust like karma points on Reddit. Say something useful, get a point. Say something dumb, lose a point.`}</p>
    <p>{`Deliver a project on time. +2 points. Find an edge case in the spec and talk to the PM. +5 points. Refactor a tricky piece of code and improve everyone's lives. +10 points.`}</p>
    <p>{`Kill production because of a typo. -20 points.`}</p>
    <p>{`Take ownership, fix the typo, and explain how you'll ensure a typo never gets into production again. +10 points.`}</p>
    <p>{`Oh and you just added to The Process. oops.`}</p>
    <p><img parentName="p" {...{
        "src": "/ce007d455661c3ad4e7d31cf1b5df2b6/media-Bt25ZEJhDt79e-giphy.gif",
        "alt": "karma giphy"
      }}></img></p>
    <p><strong parentName="p">{`responsibility`}</strong></p>
    <p>{`Second, you need to take responsibility.`}</p>
    <p>{`When something goes wrong and you followed The Process, your ass is covered. Process is the ultimate cover-your-ass strategy.`}</p>
    <p><em parentName="p">{`"Oh but I was just following the process. You should fix that if you want to fix this sort of mistake"`}</em></p>
    <p>{`Weak move my friend. -5 trust points, but I get it.`}</p>
    <p>{`/me throws another step onto The Process`}</p>
    <p>{`When you hack the process, it's all on you. Everything works out? You're a hero.`}</p>
    <p>{`Production goes down, customer gets double-charged, investor sees a blank page instead of an app demo 👉 your ass is grass.`}</p>
    <p><strong parentName="p">{`And you gotta `}<em parentName="strong">{`own`}</em>{` it.`}</strong>{` Take full responsibility. You hacked the process and it didn't work out. Own it, apologize, fix the mistake, explain the incentives, move on.`}</p>
    <p>{`But without ownership, you'll never be trusted to hack the process ever again.`}</p>
    <p><strong parentName="p">{`judgement`}</strong></p>
    <p>{`The last step is good judgement.`}</p>
    <p>{`You're about to hack The Process. Is it worth the risk?`}</p>
    <p>{`Think of risk like jumping over a canyon. You have to balance probability and consequence.`}</p>
    <p>{`Let me explain with a crude comic of a stick figure jumping over a canyon 👇`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/5068c/95teOop.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "81.61434977578475%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'326\\'%20viewBox=\\'0%200%20400%20326\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M38%208l-6%207-4%206c1%200%202%200%202-2%204-5%204%2053%200%2083-4%2022-4%2028-3%20121v70h-3l-8-1c-5-2-11-2-12-1l2%201h9l9%203c3%200%203%200%202%203l1%203%201-3v-3l15-1h149c29%200%2049%200%2068-2a920%20920%200%20015-1c-44%202-64%203-64%201v-2l-1%202-29%201H29v-23c-1-156-1-147%204-179l1-44c0-31%201-33%203-35l2-3v5l1%205V5l-2%203m175%2049l13%201h19v7l-3%2019c-2%2016-2%2041%200%2042v-1c-1-2%200-29%202-45l2-17%201-6-18-1c-12%200-17%200-16%201M88%2058H73l-32%202h2l25-1h23v7l-2%2011c-3%208-5%2023-5%2033l2%2024c1%200%201-3-1-21%200-9%202-29%206-38%202-6%202-18-1-18l-2%201m15%207l-1%2011a234%20234%200%2000-5%2049c0-10%203-33%206-49%202-9%202-15%201-17-1-1-1%201-1%206m250%20161h-15v8h-90v-7h-16l-16%201%207%201h22c1%200%202%201%202%203v4h92v-4c0-5%200-5%2028-5l21-1-10-1-25%201m-207%203l-22%202-13%201v9H92v-6l1-5h-6l-16%201-20%201h-8c4%201%2032%201%2043-1h6v5l-1%206h18l3%201v-5c0-4%200-5%202-5a421%20421%200%200143-4h-11\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/ca0a1/95teOop.webp 223w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/75680/95teOop.webp 445w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/8d1ba/95teOop.webp 890w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/3838e/95teOop.webp 1335w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/e11e5/95teOop.webp 1780w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/e0fd9/95teOop.webp 1917w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/e92b6/95teOop.png 223w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/e66bf/95teOop.png 445w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/4ef49/95teOop.png 890w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/4e814/95teOop.png 1335w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/701e9/95teOop.png 1780w", "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/5068c/95teOop.png 1917w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/f9088f3ac8f0bc166f2c3bbc4ef5c16e/4ef49/95teOop.png",
              "alt": "95teOop",
              "title": "95teOop",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Good judgement means you can tell the difference between these situations.`}</p>
    <p>{`Hacking The Process when probability of failure is low and consequences are nil? Go for it.`}</p>
    <p>{`Hacking The Process when probability of failure is high and consequences are dire? Please reconsider.`}</p>
    <h2 {...{
      "id": "so-how"
    }}>{`So how`}</h2>
    <p>{`Ok so you've got the trust, responsibility, and judgement to hack The Process. Now what?`}</p>
    <p>{`Now you find opportunities to hack the process, my friend.`}</p>
    <p>{`Start simple like disabling a merge check or two when it gets in the way of deploying a well-tested branch to production in a timely manner. Re-enable after you're done.`}</p>
    <p>{`Drop a step or five from the feature development checklist when it feels unnecessary. Does your feature actually benefit from QA or will automated tests do a better job? Does what you're doing even need automated tests? Do `}<em parentName="p">{`you`}</em>{` need a detailed checklist estimate to think through a feature?`}</p>
    <p>{`Just don't be late. `}<em parentName="p">{`"Multiply your gut estimate by 3.14"`}</em>{` is a rule of thumb I've heard a lot.`}</p>
    <p>{`You can graduate from there to completely subverting The Process.`}</p>
    <p>{`Something broken? Just fix it. Don't wait for a spec.`}</p>
    <p>{`Glaring hole in the spec? Propose a solution, tell the PM, let them add to the spec.`}</p>
    <p>{`Better yet, `}<em parentName="p">{`implement`}</em>{` the solution and show your PM a screenshot. They'll be happy as heck.`}</p>
    <p><strong parentName="p">{`Everyone loves it when you have their back.`}</strong></p>
    <p>{`As long as implementing a quick solution doesn't take you 5 days and blows your estimate to shreds. Make that the next project instead :)`}</p>
    <p>{`And most of all: `}<strong parentName="p"><em parentName="strong">{`use your hacks to improve The Process`}</em></strong></p>
    <p>{`Every improvement starts as an experiment. `}<em parentName="p">{`YOU`}</em>{` can make life better for everyone my friend.`}</p>
    <p>{`Happy hacking.`}</p>
    <p>{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      